// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Umn0","header":"MessagesList_header__2laG9","chat":"MessagesList_chat__2SjCl"};